import { auth } from '@/lib/firebase';

export class FirebaseAuthNotReadyError extends Error {
  constructor() {
    super('Firebase auth is not ready');
    this.name = 'FirebaseAuthNotReadyError';
  }
}

export async function getFirebaseIdToken(): Promise<string> {
  const user = auth.currentUser;

  if (!user) {
    throw new FirebaseAuthNotReadyError();
  }

  return user.getIdToken();
}
